import FixaSSRIcon from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/FixaSSRIcon";
import CircleFilledIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/CircleFilledIconPath";
import { ComponentNotificationTitleCreatorStatus } from "./types/task-notification.types";
import { getTitleAssignerString } from "./utils/task-notification-title";
import styles from "./task-notification.module.css";
import { useTranslation } from "@coworker/locales";

interface TaskNotificationTitleCreatorStatusProps extends ComponentNotificationTitleCreatorStatus {
  read: boolean;
}
export const TaskNotificationTitleCreatorStatus = ({
  props: { status, statusChangeBy },
  read,
}: TaskNotificationTitleCreatorStatusProps) => {
  const { t } = useTranslation();
  const changedByString = getTitleAssignerString(statusChangeBy);
  return (
    <div className={styles["task-notification-item-title"] ?? ""}>
      {!read && <FixaSSRIcon paths={CircleFilledIconPath} />}
      {status === "COMPLETED"
        ? t("hasCompletedTaskCreatedByYouString", {
            changeBy: changedByString,
          })
        : t("hasClosedTaskCreatedByYouString", {
            changeBy: changedByString,
          })}
    </div>
  );
};
